import SettingsStore from "SettingsStore";
import SymbolType from "SymbolType";
import MiniListStore from "MiniListStore";
import { DataGraphConstants } from "../../../Constants/DataGraphConstants";
import { RiPanelConstants } from "../../../Constants/RiPanelConstants";
import RiPanelTransactionsSettings from "../../../Stores/ConsoleWindow/Settings/Modules/DataGraph/RelatedInfoPanel/RiPanelTransactionsSettings";

const { ActionTypes } = RiPanelConstants;

const initState = {
    loading: true,
    transactionsSettings: new RiPanelTransactionsSettings(),
    userPortfolios: [],
    transactionsData: [],
    computedTransactionData: [],
    unitCostNodes: [],
    computedUnitCostNodes: [],
    roundTripsChartDatas: [],
    computedRoundTripsChartDatas: [],
    applicableInstrumentsTransactions: [
        SymbolType.USSTOCK,
        SymbolType.INTERNATIONALSTOCK,
        SymbolType.ADR,
        SymbolType.PREIPO,
        SymbolType.REIT,
    ],
};

const updateTooltip = (isTransactionsVisible, isRoundtripShadingVisible, computedRoundTripsChartDatas) => {

    if (computedRoundTripsChartDatas.length > 0 && (!isTransactionsVisible || !isRoundtripShadingVisible)) {
        for (const roundTrip of computedRoundTripsChartDatas) {
            roundTrip.showBox = false
            roundTrip.stick = false
        }
    }
}

const RiPanelTransactionsReducer = (state = initState, action) => {
    switch (action.type) {
        case ActionTypes.TRANSACTIONS_DATA_READY:
            return { ...state, transactionsSettings: action.transactionsSettings };

        case ActionTypes.SET_TRANSACTION_OPACITY:
            state.transactionsSettings.tranOpacity = action.tranOpacity;
            SettingsStore.saveSettings();
            return { ...state };

        case ActionTypes.SET_USER_PORTFOLIOS: 
        return {
            ...state,
            userPortfolios: action.userPortfolios,
            loading: false,
        };

        case ActionTypes.SET_TRANSACTIONS_DATA:
            return {
                ...state,
                transactionsData: action.transactionsData,
            };

        case ActionTypes.SET_COMPUTED_TRANSACTIONS_DATA:
            return {
                ...state,
                computedTransactionData: action.computedTransactionData,
            };

        case ActionTypes.SET_COSTS_DATA:
            return {
                ...state,
                unitCostNodes: action.unitCostNodes,
            };

        case ActionTypes.SET_COMPUTED_COSTS_DATA:
            return {
                ...state,
                computedUnitCostNodes: action.computedUnitCostNodes,
            };

        case ActionTypes.SET_ROUNDTRIP_DATA:
            return {
                ...state,
                roundTripsChartDatas: action.roundTripsChartDatas,
            };
        case ActionTypes.SET_COMPUTED_ROUNDTRIP_DATA:
            return {
                ...state,
                computedRoundTripsChartDatas: action.computedRoundTripsChartDatas,
            };

        case ActionTypes.UPDATE_SELECTED_PORTFOLIO_ID: {
            let selectedPortfolios = state.transactionsSettings.selectedPortfolios.includes(action.portfolioId) 
            ? state.transactionsSettings.selectedPortfolios.filter((item) => item !== action.portfolioId) 
            : [...state.transactionsSettings.selectedPortfolios, action.portfolioId]
            state.transactionsSettings.selectedPortfolios = [...selectedPortfolios]
            SettingsStore.saveSettings();
            return { ...state };
        }

        case ActionTypes.TOGGLE_TRANSACTION_VISIBLE:
            state.transactionsSettings.isTransactionsVisible = !state.transactionsSettings.isTransactionsVisible;
            updateTooltip(state.transactionsSettings.isTransactionsVisible, state.transactionsSettings.isRoundtripShadingVisible, state.computedRoundTripsChartDatas);
            SettingsStore.saveSettings();
            return { ...state };

        case ActionTypes.TOGGLE_SHADING_VISIBLE:
            state.transactionsSettings.isRoundtripShadingVisible = !state.transactionsSettings.isRoundtripShadingVisible;
            updateTooltip(state.transactionsSettings.isTransactionsVisible, state.transactionsSettings.isRoundtripShadingVisible, state.computedRoundTripsChartDatas);
            SettingsStore.saveSettings();
            return { ...state };

        case ActionTypes.UPDATE_DELETED_PORTFOLIO:
            const selectedPortfolios = state.transactionsSettings.selectedPortfolios;
            state.transactionsSettings.selectedPortfolios = selectedPortfolios.filter((item) => item !== action.portfolioID);
            SettingsStore.saveSettings();
            return { ...state };

        case ActionTypes.UPDATE_LATEST_PORTFOLIO:{
            const selectedPortfolios = state.transactionsSettings.selectedPortfolios;
            const filteredPortfolios = selectedPortfolios.filter((item) => item !== action.portfolioID);
            filteredPortfolios.push(action.portfolioID);
            state.transactionsSettings.selectedPortfolios = filteredPortfolios;
            SettingsStore.saveSettings();
            return { ...state };
        }

        // reset transaction states while changing periodicity or symbol
        case DataGraphConstants.ActionTypes.PRICE_PANEL_RESPONSE_READY:
            return {
                ...state,
                transactionsData: [],
                computedTransactionData: [],
                unitCostNodes: [],
                computedUnitCostNodes: [],
                roundTripsChartDatas: [],
                computedRoundTripsChartDatas: [],
            };

        default:
            return state;
    }
};

export default RiPanelTransactionsReducer;
